import { render, staticRenderFns } from "./docExpiredColdWater.vue?vue&type=template&id=17c87a20"
import script from "./docExpiredColdWater.vue?vue&type=script&lang=js"
export * from "./docExpiredColdWater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports